import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Info } from "lucide-react";
import { api } from "../lib/api";

const BOX = {
  success: ["border-emerald-200 bg-emerald-50 text-emerald-900", CheckCircle2, "text-emerald-600"],
  error: ["border-red-200 bg-red-50 text-red-900", XCircle, "text-red-600"],
  pending: ["border-slate-200 bg-slate-50 text-slate-800", Loader2, "text-primary animate-spin"],
  info: ["border-slate-200 bg-slate-50 text-slate-800", Info, "text-slate-500"],
};

export default function CheckoutResult({ onActivated }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const cancelled = params.get("checkout") === "cancel";
  const [state, setState] = useState(sessionId ? { kind: "pending", text: "Stiamo confermando il pagamento con Stripe…" } : cancelled ? { kind: "info", text: "Pagamento annullato: nessun addebito è stato effettuato e il piano non è cambiato." } : null);

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/billing/checkout-status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState({ kind: "success", text: "Pagamento riuscito! Il tuo piano è attivo." });
          onActivated?.();
          navigate("/billing", { replace: true });
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) {
          setState({ kind: "error", text: `${data.error || "Pagamento non riuscito"}: la carta è stata rifiutata o il pagamento non è andato a buon fine. Il piano NON è stato attivato.` });
          return;
        }
      } catch (e) {
        setState({ kind: "error", text: "Non riusciamo a verificare il pagamento. Il piano non è stato attivato: contatta l'assistenza se hai ricevuto un addebito." });
        return;
      }
      if (tries >= 20) {
        setState({ kind: "info", text: "Il pagamento è ancora in elaborazione. Il piano si attiverà automaticamente appena Stripe lo conferma: aggiorna la pagina tra qualche minuto." });
        return;
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId, navigate, onActivated]);

  if (!state) return null;
  const [cls, Icon, iconCls] = BOX[state.kind];
  return (
    <div data-testid={`checkout-result-${state.kind}`} className={`mb-6 rounded-xl border px-5 py-4 flex items-start gap-3 ${cls}`}>
      <Icon style={{ width: 20, height: 20 }} className={`shrink-0 mt-0.5 ${iconCls}`} />
      <p className="text-sm font-medium">{state.text}</p>
    </div>
  );
}
